<template>
  <div class="form-group">
    <div class="d-flex justify-content-between">
      <label v-if="label" class="form-label text-muted">
        {{ label }} <i v-if="required" class="text-danger">*</i>
      </label>
      <slot name="labelContentEnd"></slot>
    </div>
    <!-- v-model.number="model.$model" -->
    <!-- EXCLUSIVO DO MAIN: maxlength -->
    <input
      v-model.lazy="model.$model"
      class="form-control"
      v-money3="config"
      :class="{ 'is-invalid': model.$error }"
      type="text"
      :maxlength="maxLength ?? undefined"
      :placeholder="placeholder"
      :style="inputStyle"
    />
    <div class="invalid-feedback">
      <small>{{ errorMsg }}</small>
    </div>
    <slot name="content"></slot>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    model?: any;
    label?: string;
    placeholder?: string;
    errorMsg?: string;
    inputStyle?: string | null;
    required?: boolean;
    maxLength?: number | null;
  }>(),
  {
    model: () => ({}),
    label: "",
    placeholder: "",
    errorMsg: "Por favor, preencha este campo corretamente",
    inputStyle: null,
    required: false,
  },
);

const config = {
  prefix: "R$ ",
  thousands: "",
  decimal: ",",
  precision: 2,
  disableNegative: true,
  minimumNumberOfCharacters: 1,
  modelModifiers: {
    number: true,
  },
};
</script>
